<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<script>
/**
 * @module raster-source/source
 */
import RasterSource from 'ol/source/Raster';
import tileSource from 'vuelayers/lib/mixin/image-source';
import {hasSource} from 'vuelayers/lib/util/assert';
import {observableFromOlEvent} from 'vuelayers/lib/rx-ext';

const props = {
  sources: {type: Array},
  operation: {type: Function},
  lib: {type: Object},
};

const methods = {
  createSource() {
    return new RasterSource({
      sources: this.sources,
      operation: this.operation,
      lib: this.lib,
    });
  },
  subscribeAll() {
    subscribeToRasterSourceEvents.call(this);
  },
  unmount() {
    terminateWorkers.call(this);
    tileSource.methods.unmount.call(this);
  }
};

const watch = {
  operation() {
    terminateWorkers.call(this);
    this.$source.setOperation(this.operation, this.lib);
  },
  lib() {
    terminateWorkers.call(this);
    this.$source.setOperation(this.operation, this.lib);
  }
};

export default {
  name: 'vl-source-raster',
  mixins: [tileSource],
  props,
  methods,
  watch
};


/**
 * Fix worker termination in ol 5.3. It has been fixed in recent versions.
 * WARNING: Only guaranteed to work as expected for the usage we have of `ol.RasterSource`
 */
function terminateWorkers() {
  const processor = this.$source.worker_;
  if (processor) {
    for (let i = 0; i < processor._workers.length; i++) {
      processor._workers[i].terminate();
    }
  }
}

function subscribeToRasterSourceEvents () {
  hasSource(this)

  const events = observableFromOlEvent(this.$source, [
    'beforeoperations',
    'afteroperations'
  ])

  this.subscribeTo(events, evt => this.$emit(evt.type, evt))
}

</script>
